
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 import { SkyChip as SkyChipElement, SkyChipRemovedEventDetail } from '@sky.ui/core/sky-chip';
 
 

 
 export const SkyChip = createComponent({
   displayName: 'SkyChip',
   react: React,
   tagName: 'sky-chip',
   elementClass: SkyChipElement,
   events: {
     
     onChipRemoved: 'chip-removed' as EventName<CustomEvent<SkyChipRemovedEventDetail>>,
   }
  });
export type * from '@sky.ui/core/sky-chip';
